import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import ChatWidget from "@/components/ChatWidget";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <ChatWidget />
        <Toaster />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
